export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
export const SET_SNACKBAR_ALERT = 'SET_SNACKBAR_ALERT';
